var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSellerApplets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.261 4.732c1.202 0 2.18.903 2.18 2.022 0 .348-.1.688-.282.994a2.162 2.162 0 01-1.243.937c-.14.041-.249.058-.348.058a.41.41 0 01-.414-.415.41.41 0 01.414-.414c.017 0 .05 0 .091-.017.356-.099.638-.306.796-.58.107-.174.157-.364.157-.563 0-.655-.605-1.194-1.342-1.194-.257 0-.506.067-.73.191-.39.224-.621.597-.621 1.003v3.472c0 .705-.39 1.351-1.036 1.716a2.28 2.28 0 01-1.136.298c-1.201 0-2.18-.903-2.18-2.022 0-.348.1-.688.283-.995a2.162 2.162 0 011.243-.936c.149-.041.248-.058.348-.058a.41.41 0 01.414.414.41.41 0 01-.414.415c-.017 0-.05 0-.091.016-.357.108-.638.315-.796.58a1.054 1.054 0 00-.157.564c0 .655.605 1.193 1.35 1.193.257 0 .506-.066.73-.19.39-.224.621-.597.621-1.003V6.754c0-.705.39-1.351 1.036-1.716.34-.207.73-.306 1.127-.306h0zM1.833 8.46a6.628 6.628 0 006.63 6.63 6.628 6.628 0 006.63-6.63 6.628 6.628 0 00-6.63-6.63 6.628 6.628 0 00-6.63 6.63zm-.829 0a7.46 7.46 0 1114.919.001 7.46 7.46 0 01-14.919-.001z",
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.5
  })));
}

export default SvgSellerApplets;